import axios from 'axios';

const localApi = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL
})

export default localApi;